import React from 'react';
import { Bubble } from 'tea-component';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import { formatDateStr, getTencentAvatarSrc } from '@gp/utils/common';

import './index.scss';

interface IType {
  id: string;
  img: string;
  title: string;
  time: string;
  details:
  | {
    field: string;
    origin_value: string;
    value: string;
  }[]
  | null;
}

interface HistoryBubblePropsType {
  loading: boolean;
  newTime: string;
  timeList?: IType[] | null;
}

const HistoryBubble: React.FC<HistoryBubblePropsType> = (props) => {
  const { loading, newTime, timeList: timeListProps } = props;

  const timeList = timeListProps?.filter((timeItem) => {
    const { title, time } = timeItem || {};
    return !!title || !!time;
  });
  const newTimeFormatted = formatDateStr(newTime);

  if (!newTimeFormatted) return null;

  return (
    <Bubble
      dark
      // placement={'top'}
      // trigger={'click'}
      destroyOnClose={false}
      overlayClassName="dbg-history-bubble-overlay"
      content={
        !Array.isArray(timeList) || !timeList?.length || loading || !newTimeFormatted ? undefined : (
          <div className="dbg-history-bubble-box">
            {timeList?.map((item: IType) => (
              <div key={item?.id} className="dbg-history-bubble-item">
                {/* <img className="dbg-history-bubble-img" src={item?.img} /> */}
                <GeneralImageNew
                  className="dbg-history-bubble-img"
                  domain="user"
                  width={20}
                  height={20}
                  src={getTencentAvatarSrc(item?.title)}
                />
                <span className="dbg-history-bubble-desc">
                  <span>
                    {item?.title || '-'}
                    <span> updated on </span>
                    {formatDateStr(item?.time) || '-'}
                  </span>
                  {Array.isArray(item?.details) &&
                    item?.details?.length > 0 &&
                    item?.details?.map((t, i) => (
                      <>
                        <br />
                        <span key={i} className="dbg-history-bubble-desc_details">
                          {t?.field} changed from {t?.origin_value || '-'} to {t?.value || '-'}
                        </span>
                      </>
                    ))}
                </span>
              </div>
            ))}
          </div>
        )
      }
    >
      <div className="dbg-history-bubble-text">Updated on {newTimeFormatted || '-'}</div>
    </Bubble>
  );
};

export default HistoryBubble;
